module.exports = __webpack_public_path__ + "img/38.a79d3c61.jpg";